const unitShortName = {
  'act': 'acted',
  'am': 'amount',
  'at': 'attack',
  'bam': 'baseAmount',
  'bat': 'baseAttack',
  'bdm': 'baseDamage',
  'bdf': 'baseDefense',
  'bhp': 'baseHitPoints',
  'bst': 'baseShots',
  'bsp': 'baseSpeed',
  'bf': 'buffs',
  'cc': 'canBeCast',
  'x': 'col',
  'cl': 'color',
  'dm': 'damage',
  'dbf': 'debuffs',
  'df': 'defense',
  'fc': 'faction',
  'hp': 'hitPoints',
  'hpl': 'hitPointsLeft',
  'id': 'id',
  'idf': 'isDefend',
  'idw': 'isDoubleWide',
  'if': 'isFlying',
  'k': 'killed',
  'lv': 'level',
  'lk': 'luck',
  'mr': 'morale',
  'mp': 'movePath',
  'n': 'name',
  'nc': 'nameCn',
  'om': 'onlyMeleeFight',
  'pid': 'playerId',
  'rg': 'range',
  'y': 'row',
  'st': 'shots',
  'std': 'shottedDistance',
  'sd': 'side',
  'sp': 'speed',
  'tid': 'teamId',
  'w': 'waited'
}

export default {
  unitShortName,
}
